


window.theme = window.theme || {}

if ($(".new-arrivals-bg").length > 0 || $("#animation-scene-1").length > 0) {
	theme.scrollMagic = (function () {
		const ctrl = new ScrollMagic.Controller()
		const gradientTween = new TimelineMax()

		gradientTween.to(".new-arrivals-bg", 1, {
			filter: "hue-rotate(-90deg)",
		})

		const gradientScene = new ScrollMagic.Scene({
			triggerElement: ".new-arrivals",
			triggerHook: 0.7,
			duration: "300%",
		})
			.addTo(ctrl)
			.setTween(gradientTween)

        if($("#animation-scene-1").length > 0) {
        
          const sectionOneAnimationDefinition = (() => {
              const tweens = new TimelineMax()

              const topText = new TweenMax.to("#textTop", 2.5, {
                  scale: 3.5,
                  y: "-600%",
              })
              const bottomText = new TweenMax.to("#textBottom", 2.5, {
                  scale: 3.5,
                  y: "600%",
              })

              const secondaryImage = new TweenMax.to("#secondaryImage", 2.5, {
                scale: 1,
              })
              const captionTwo = new TweenMax.to("#caption-2", 2.5, {
                scale: 1,
              })

              tweens.add(topText, "first").add(bottomText, "first").add(secondaryImage, "first").add(captionTwo, "first")

              const sectionOne = new ScrollMagic.Scene({
                  triggerElement: "#animation-scene-1",
                  duration: "100%",
              })
                  .setPin("#animation-scene-1")
                  .setTween(tweens)
                  .triggerHook(0)
                  .addTo(ctrl)
          })()
          
    	}
	})()
}

theme.utils = (function () {
	const showToast = (message, type) => {
		nativeToast({
			message,
			timeout: 5000,
			rounded: true,
			position: "south",
			closeOnClick: true,
			type: typeof type !== "undefined" ? type : "success",
		})
	}
	const init = () => {
		AOS.init()
		$(".mega-menu").mouseleave(function () {
			$(".mega-menu").removeClass("active")
			$('body').css('overflow','auto')
		})
		$(".parent").mouseenter(function () {
			$(".mega-menu").removeClass("active")
			$(this).next(".mega-menu").addClass("active")
			$('body').css('overflow','hidden')
		})
		$(".mobile-toggle").click(function (e) {
			e.preventDefault()
			if ($(".mobile-menu").hasClass("mobile-active")) {
				$(".mobile-menu").fadeOut().removeClass("mobile-active")
			} else {
				$(".mobile-menu").fadeIn().addClass("mobile-active")
			}
		})

		$(".mobile-menu .main-parent").click(function (e) {
			e.preventDefault()
			if ($(this).next().hasClass("child-opened")) {
				$(this).next().removeClass("child-opened").fadeOut()
			} else {
				$(this).next().addClass("child-opened").fadeIn()
			}
		})

		$(".mobile-menu .main-child").click(function (e) {
			e.preventDefault()
			const $this = $(this)
			$(".mobile-menu .main-child").fadeOut(function () {
				$this.next().addClass("childest-opened").fadeIn()
			})
		})

		$(".mobile-menu .main-childest-back").click(function (e) {
			e.preventDefault()
			const $this = $(this)
			$this
				.parent()
				.fadeOut(function () {
					$this.parents(".childs-list").addClass("child-opened")
					$this.parent().siblings(".main-child").fadeIn()
				})
				.removeClass("childest-opened")
		})

		$("[data-toggle-search]").click(function (e) {
			e.preventDefault()
			$(this).next().toggleClass("active")
		})

		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				$(".header").addClass("dark")
			} else {
				$(".header").removeClass("dark")
			}
		})

		$("[data-tab-show]").click(function (e) {
			e.preventDefault()

			$("[data-tab-show]").removeClass("active")
			$(this).addClass("active")

			const $toShow = $($(this).data("tab-show"))

			$(".tabs .content").hide()

			$toShow.show(function () {
				console.log(`Tab ${$toShow} has been opened.`)
			})
		})

		if ($(".animated-text-marquee3k").length > 0) {
			Marquee3k.init({
				selector: "animated-text-marquee3k",
			})
		}

		// blogs load more button
		$("body").on("click", "[data-load-more]", async function (e) {
			e.preventDefault()

			const pagination = "#load-more-pagination"
			const container = "#load-more-container"

			const next = $(this).attr("href")
			const $pagination = $(this).parent(pagination)
			const $container = $pagination.prev(container)

			if (next && $pagination && $container) {
				console.log("Loading a page by URL", next)
				try {
					$(this).find("span").text("Loading")
					let response = await fetch(`${next}`)
					if (!response.ok) throw "Fetch error!"
					response = await response.text()

					appendArticles(response)
					changePaginationURL(response)
					$(this).find("span").text("Load More")
				} catch (error) {
					console.error(error)
					console.error(error.message)
				}

				function appendArticles(resp) {
					const $result = $(resp).find(container)
					const $children = $result.children()
					$container.append($children)
				}

				function changePaginationURL(resp) {
					const $result = $(resp).find(pagination)
					$pagination.replaceWith($result)
				}
			}
		})

		// collection filters
		$("[data-filters-toggle]").click(function (e) {
			e.preventDefault()
			const $filters = $(".filters-content")
			let isActive = $filters.hasClass("active")
			if (isActive) {
				$filters.hide()
				$filters.removeClass("active")
				$("[data-filters-toggle]").removeClass("active")
			} else {
				$filters.show()
				$filters.addClass("active")
				$("[data-filters-toggle]").addClass("active")
			}
			isActive = !isActive
		})

		// blog-events accordion
		$(".coming-accordion .current").click(function (e) {
			e.preventDefault()
			if ($(this).next().hasClass("active")) {
				$(this).next().fadeOut().removeClass("active")
			} else {
				$(this).next().fadeIn().addClass("active")
			}
		})

		// careers-and-opportunities page
		$(".accordion-item .accordion-item__header").on("click", function (e) {
			e.preventDefault()
			$(this).next().fadeToggle()
		})

		// Captcha button
		if ($(".shopify-challenge__button")) {
			$(this).addClass("btn-primary")
			$(".shopify-challenge__button").addClass("btn-primary").css("border", "none")
		}

		// Scroll to product on collections pages
		if (!window.location.pathname.includes("collections") && !window.location.pathname.includes("products")) {
			const productID = localStorage.getItem("productID")
			if (productID) {
				console.log(`Removed ${productID} from local storage!`)
				localStorage.removeItem("productID")
			}
		}

		$(".product-item").click(function () {
			console.log(`Added ${$(this).parent().attr("id")} to local storage!`)
			localStorage.setItem("productID", $(this).parent().attr("id"))
		})
		// Scroll to product on collections pages //

		// article masonry
		if ($("section.masonry-items").length > 0) {
			const $grid = $("section.masonry-items").imagesLoaded(function () {
				$grid.masonry({
					itemSelector: ".masonry-item",
					columnWidth: ".masonry-sizer",
					gutter: 0,
					percentPosition: true,
				})
			})
		}
	}
	return {
		init,
		showToast,
	}
})()

theme.cart = (function () {
	const updateCart = async ($item) => {
		try {
			let response = await fetch("/cart/change.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ quantity: $item.val(), id: $item.data("item-key") }),
			})
			if (!response.ok) {
				throw response
			}

			theme.utils.showToast($item.val() > 0 ?  "Quantity changed!" : "Deleted!")

			window.location.pathname.includes(window.Shopify.routes.cartUrl) ? reloadCart() : reloadAjaxCart()
		} catch (error) {
			console.error("Update cart error", error)

			if (error?.status == 422) {
				theme.utils.showToast("Out Of Stock!", "error")
			} else {
				theme.utils.showToast("Update cart error!", "error")
			}
		}
	}
	const addToCart = async (formData) => {
		try {
			const response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			})
			if (!response.ok) {
				throw response
			}
			console.log("Successed!")
			theme.utils.showToast("Added!")
			reloadAjaxCart()
			return await response.json()
		} catch (error) {
			console.error("Add to cart failed", error)

			if (error?.status == 422) {
				theme.utils.showToast("Out Of Stock!", "error")
			} else {
				theme.utils.showToast("Please select a size", "error")
			}
		}
	}

	const reloadAjaxCart = function () {
		console.log("reloadAjaxCart")
		$(".cart").addClass("active")
		$(".cart .content-loader").empty().append(`<div class="ring-loader"><div></div><div></div><div></div><div></div></div>`)
		$(".cart .content-loader").load("/cart?view=ajax", function () {
			const cartJson = JSON.parse($(".content-loader").find("#cartJSON").text())
			$(".btn-add-to-cart .count").text(cartJson.item_count)
			// commands here
			$("[data-remove-item-cart]").click(function (e) {
				e.preventDefault()
				updateCart($(this))
			})
			$("[data-update-item-cart]").click(function (e) {
				e.preventDefault()
				updateCart($(this))
			})
		})
	}

	const reloadCart = function () {
		$(".main-cart .content-loader").empty().append(`<div class="ring-loader"><div></div><div></div><div></div><div></div></div>`)
		$(".main-cart .content-loader").load("/cart .main-cart .content-loader", function () {
			const cartJson = JSON.parse($(".main-cart").find("#cartJSON").text())
			$(".btn-add-to-cart .count").text(cartJson.item_count)
			// commands here
			$("[data-update-item-cart]").click(function (e) {
				e.preventDefault()
				updateCart($(this))
			})
		})
	}

	const init = function () {
		console.log('init theme cart');
		$(".product-variant input").change(function (e) {
			e.preventDefault()
			const $money = $(this).parents(".product-content").find(".current")
			$money.text($(this).data("variant-price"))
		})

		$("[data-add-to-cart]").click(function (e) {
			e.preventDefault()
			const formData = {
				items: [
					{
						id: $(this).parents(".product-info").find("input:checked").val(),
						quantity: $(this).parents(".product-info").find("input[name='quantity']").val(),
					},
				],
			}
			addToCart(formData)
		})

		$("[data-update-item-cart]").click(function (e) {
			e.preventDefault()
			console.log("update")
			updateCart($(this))
		})

		$("[data-toggle-cart]").click(function (e) {
			e.preventDefault()

			let isActive = $(".cart").hasClass("active")
			if (isActive) {
				$(".cart").removeClass("active")
			} else {
				reloadAjaxCart()
			}
			isActive = !isActive
		})
	}
	return {
		init,
		addToCart,
	}
})()

theme.carouseles = (function () {
	const homepageCarouselInit = () => {
		const carousel = ".homepage-carousel.owl-carousel"
		const settings = {
			items: 1,
			dots: true,
			nav: true,
			rewind: true,
			autoplay:true,
			autoplayTimeout:5000,
			responsive:{
				600:{
					nav: false
				}
			}
		}
		$(carousel).owlCarousel(settings)

		Shopify.designMode &&
			document.addEventListener("shopify:section:load", (event) => {
				if ($(event.target).hasClass("hero-slideshow")) {
					console.log("Homepage hero carousel has been reload!")

					$(carousel).trigger("destroy.owl.carousel")
					$(carousel).owlCarousel(settings)
				}
			})
	}
	const swiperCarouselsInit = () => {
		const newArrivals = new Swiper(".new-arrivals-carousel", {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 0,
			mousewheel: true,
			breakpoints: {
				425: {
					slidesPerView: 2,
					spaceBetween: 5,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
			},
		})

		$(".new-arrivals-carousel .swiper-slide")
			.on("mouseover", function () {
				newArrivals.autoplay.stop()
			})
			.on("mouseout", function () {
				newArrivals.autoplay.start()
			})
	}
	const activeCarouseles = [
			{
				selector: "#index-releases-slider",
				getSettings: function () {
					return {
						nav: $(this.selector).data("nav"),
						dots: $(this.selector).data("dots"),
						loop: $(this.selector).data("loop"),
						autoplay: $(this.selector).data("autoplay"),
						autoplayHoverPause: true,
						navText: ["<span></span>", "<span></span>"],
						center: true,
						startPosition: 2,
						responsive: {
							1023: {
								margin: 10,
								items: $(this.selector).data("items"),
							},
							639: {
								margin: 40,
								items: 3,
							},
							300: {
								margin: 20,
								items: 1,
							},
						},
						onInitialized: function (event) {
							const owlID = event.target.id
							console.log(`${owlID} has been initialized.`)
						},
					}
				},
			},
			{
				selector: "#product-template-slider",
				getSettings: function () {
					return {
						nav: $(this.selector).data("nav"),
						dots: $(this.selector).data("dots"),
						loop: $(this.selector).data("loop"),
						navText: ["<span></span>", "<span></span>"],
						responsiveClass: true,
						responsive: {
							639: {
								items: 1,
							},
							300: {
								items: 1,
							},
						},
						onInitialized: function (event) {
							const owlID = event.target.id
							console.log(`${owlID} has been initialized.`)
						},
					}
				},
			},
			{
				selector: "#product-release-template-slider",
				getSettings: function () {
					return {
						nav: $(this.selector).data("nav"),
						dots: $(this.selector).data("dots"),
						loop: $(this.selector).data("loop"),
						navText: ["<span></span>", "<span></span>"],
						responsiveClass: true,
						responsive: {
							639: {
								items: $(this.selector).data("items"),
							},
							300: {
								items: 1,
							},
						},
						onInitialized: function (event) {
							const owlID = event.target.id
							console.log(`${owlID} has been initialized.`)
						},
					}
				},
			},
			{
				selector: "#blog-events-template-slider",
				getSettings: function () {
					return {
						nav: $(this.selector).data("nav"),
						dots: $(this.selector).data("dots"),
						loop: $(this.selector).data("loop"),
						navText: ["<div></div>", "<div></div>"],
						margin: 50,
						responsiveClass: true,
						responsive: {
							1023: {
								items: $(this.selector).data("items"),
							},
							639: {
								items: 2,
								margin: 20,
							},
							300: {
								items: 1,
							},
						},
						onInitialized: function (event) {
							const owlID = event.target.id
							console.log(`${owlID} has been initialized.`)
						},
					}
				},
			},
			{
				selector: "section.slider-images",
				getSettings: function () {
					return {
						loop: true,
						dots: true,
						nav: false,
						rewind: true,
						margin: 30,
						responsiveClass: true,
						responsive: {
							0: {
								items: 1,
							},
							440: {
								items: 2,
							},
							639: {
								items: 3,
							},
							1023: {
								items: 4,
							},
						},
						onInitialized: function (event) {
							console.log(event.target)
							const owlID = event.target.id
							console.log(`${owlID} has been initialized.`)
						},
					}
				},
			},
			{
				selector: ".products-list-slider-carousel",
				getSettings: function () {
					return {
						loop: true,
						dots: true,
						nav: false,
						rewind: true,
						responsiveClass: true,
						responsive: {
							0: {
								items: 1,
							},
							440: {
								items: 2,
							},
							639: {
								items: 3,
							},
							1023: {
								items: 4,
							},
						},
						onInitialized: function (event) {
							const target = event.target.id ? event.target.id : event.target.classList[1]
							console.log(`${target} has been initialized.`)
						},
					}
				},
			},
			{
				selector: "#special-article-slider-carousel",
				getSettings: function () {
					return {
						items: 1,
						loop: true,
						dots: false,
						nav: true,
						rewind: true,
						autoHeight: true,
						responsiveClass: true,
						responsive: {
							0: {
								items: 1,
							},
							440: {
								items: 1,
							},
							639: {
								items: 1,
							},
							1023: {
								items: 1,
							},							
						},
						onInitialized: function (event) {
							const target = event.target.id ? event.target.id : event.target.classList[1]
							console.log(`${target} has been initialized.`)
						},
					}
				},
			},
		],
	initializeCarousel = (carousel) => ($(carousel.selector).length > 0 ? $(carousel.selector).owlCarousel(carousel.getSettings()) : false)
	reInitializeCarousel = (selector) => {
		$(selector).trigger("destroy.owl.carousel")
		initializeCarousel(activeCarouseles.filter((carousel) => carousel.selector == selector)[0])
	}
	// Initializing
	const init = function () {
		activeCarouseles.forEach(initializeCarousel)
		swiperCarouselsInit()
		homepageCarouselInit()
	}
	return {
		init,
		reInitializeCarousel,
	}
})()

theme.loadProductRecomendations = async function () {
	//-- Recommendations on product page
	const $container = $(".recommendations")
	if ($container.length > 0) {
		const baseUrl = $container.data("base-url")
		const productId = $container.data("product-id")
		const sectionId = $container.data("section-id")
		const limit = $container.data("limit")
		const requestURL = `${baseUrl}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`

		const $mainContainer = $container.parent()
		$mainContainer.html(`<div class="loader"></div>`)

		try {
			let response = await fetch(requestURL, { method: "GET" })
			if (!response.ok) {
				throw new Error("Failed to load product recommendations.")
			}
			response = await response.text()
			$mainContainer.html(response)
			console.log("Recommended products loaded.")
		} catch (e) {
			console.error(e.message)
			$mainContainer.hide()
		}
	}
}

theme.customizer = (function () {
	if (Shopify.designMode) {
		document.addEventListener("shopify:section:load", function (event) {
			console.log("shopify:section:load triggered.")

			if ($(event.target).hasClass("shopify-section-index-releases-template")) {
				theme.carouseles.reInitializeCarousel("#index-releases-slider")
			}

			if ($(event.target).hasClass("shopify-section-product-template")) {
				theme.carouseles.reInitializeCarousel("#product-template-slider")
			}

			if ($(event.target).hasClass("shopify-section-blog-events-template")) {
				theme.carouseles.reInitializeCarousel("#blog-events-template-slider")
			}

			if ($(event.target).hasClass("shopify-section-product-release-template")) {
				theme.carouseles.reInitializeCarousel("#product-release-template-slider")
			}

			if ($(event.target).hasClass("products-list-slider-section")) {
				theme.carouseles.reInitializeCarousel(".products-list-slider-carousel")
			}

			if (event.detail.sectionId === "product-recommendations") {
				theme.loadProductRecomendations()
			}
		})
		// document.addEventListener("shopify:section:unload", function (event) {
		// 	console.log("shopify:section:unload triggered.")
		// })
		// document.addEventListener("shopify:section:select", function (event) {
		// 	console.log("shopify:section:select triggered.")
		// })
		// document.addEventListener("shopify:section:deselect", function (event) {
		// 	console.log("shopify:section:deselect triggered.")
		// })
		// document.addEventListener("shopify:section:reorder", function (event) {
		// 	console.log("shopify:section:reorder triggered.")
		// })
		// document.addEventListener("shopify:block:select", function (event) {
		// 	console.log("shopify:block:select triggered.")
		// })
		// document.addEventListener("shopify:block:deselect", function (event) {
		// 	console.log("shopify:block:deselect triggered.")
		// })
	}
})()

theme.init = function () {
	theme.utils.init()
	theme.cart.init()
	theme.carouseles.init()
	theme.loadProductRecomendations()
}

$(function () {
	theme.init()
})

$(window).on("load", function () {
	$("#page-preloader").fadeOut("slow")

	// Scroll to product on collections pages
	if (window.location.pathname.includes("collections") && !window.location.pathname.includes("products")) {
		const productID = localStorage.getItem("productID")
		if (productID) {
			// console.log("Product ID from local storage -", productID)
			if (productID.length > 0) {
				const productAnchor = "#" + productID
				if ($(".boost-pfs-filter-products").find(productAnchor).length > 0) {
					console.log(`Product with anchor ${productAnchor} finded`, $(".boost-pfs-filter-products").find(productAnchor))
					const scrollTo = $(productAnchor).offset().top - 30
					$("body,html").animate({ scrollTop: scrollTo }, 1500)
				}
			}
		}
	}
	// Scroll to product on collections pages //
})


// back to top 

var btn = $('#buttonUp');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

// back to top end 
 